/* so-collection.js — T2 collection page (slice 1): the "About" sheet and the phone Sort/Filter bar.
   Loaded (deferred) by sections/main-collection-banner.liquid. Small and event-driven on purpose (INP).

   About sheet (#so-coll-about, server-rendered so the description stays in the DOM):
     - uses the shared .so-dsheet shell (so-delivery-sheet.css) and window.soSheetSwipe for swipe-down on phones;
     - portalled to <body> on first open so no section's stacking context can clip it;
     - close on ×, backdrop, Escape or swipe; Tab is kept inside; focus goes to the title, then back to "About".
   Phone bar ([data-so-cbar], snippets/products-toolbar.liquid):
     - Filter opens the theme's facet drawer (facet-filters.open);
     - Sort is a native <select>; a change ticks the drawer's matching sort radio and fires its 'input' event, so
       facet-filters.js applies it exactly like a sort picked in the drawer;
     - after every facet re-render (on:facet-filters:updated) the "Sort: …" label and the filter count are re-read
       from the re-rendered form. */
(function () {
  'use strict';
  if (window.soCollectionBound) return;
  window.soCollectionBound = true;

  // ---------- About sheet ----------
  var sheet = null, opener = null, saved = null, closeTimer = 0;

  function onKey(e) {
    if (!sheet || sheet.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = Array.prototype.filter.call(sheet.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])'), function (el) {
      return !el.disabled && el.getClientRects().length;
    });
    if (!f.length) { e.preventDefault(); return; }
    var i = f.indexOf(document.activeElement);
    var to = e.shiftKey ? (i <= 0 ? f[f.length - 1] : f[i - 1]) : (i === -1 || i === f.length - 1 ? f[0] : f[i + 1]);
    e.preventDefault(); to.focus();
  }

  function open(btn) {
    sheet = sheet || document.getElementById('so-coll-about');
    if (!sheet) return;
    clearTimeout(closeTimer);
    if (sheet.parentNode !== document.body) document.body.appendChild(sheet);
    opener = btn;
    sheet.classList.remove('is-closing');
    sheet.hidden = false;
    sheet.removeAttribute('aria-hidden');
    saved = saved || { html: document.documentElement.style.overflow, body: document.body.style.overflow };
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    var panel = sheet.querySelector('.so-dsheet__panel');
    if (window.soSheetSwipe && panel) {
      window.soSheetSwipe.attach(panel, {
        handle: '.so-dsheet__grab, .so-dsheet__head', scroller: '.so-dsheet__body',
        backdrop: sheet.querySelector('.so-dsheet__backdrop'), onClose: close
      });
    }
    void sheet.offsetWidth;                 // reflow, then slide in
    sheet.classList.add('is-open');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    var t = sheet.querySelector('#so-coll-about-title');
    if (t) t.focus({ preventScroll: true });
    document.addEventListener('keydown', onKey, true);
  }


  function close() {
    if (!sheet || sheet.hidden || !sheet.classList.contains('is-open')) return;
    var s = sheet;
    s.classList.remove('is-open');
    s.classList.add('is-closing');
    s.setAttribute('aria-hidden', 'true');
    document.removeEventListener('keydown', onKey, true);
    if (saved) {
      document.documentElement.style.overflow = saved.html;
      document.body.style.overflow = saved.body;
      saved = null;
    }
    closeTimer = setTimeout(function () { s.hidden = true; s.classList.remove('is-closing'); }, 260);
    if (opener) {
      opener.setAttribute('aria-expanded', 'false');
      if (opener.isConnected) opener.focus({ preventScroll: true });
    }
  }

  // ---------- phone Sort / Filter bar ----------
  function sortRadios() { return document.querySelectorAll('#facets .js-drawer-sort-by'); }

  function syncBar() {
    var bar = document.querySelector('[data-so-cbar]');
    if (!bar) return;
    var checked = document.querySelector('#facets .js-drawer-sort-by:checked');
    var sel = bar.querySelector('[data-so-cbar-select]');
    var label = bar.querySelector('[data-so-cbar-sort]');
    if (checked && sel) {
      sel.value = checked.value;
      if (label && sel.selectedIndex > -1) label.textContent = sel.options[sel.selectedIndex].text;
    }
    var count = bar.querySelector('[data-so-cbar-count]');
    if (count) {
      var n = document.querySelectorAll('#facets .active-filter').length;
      count.hidden = n === 0;
      count.lastChild.textContent = ' ' + n;
    }
    applyValue();
  }

  // ---------- T2 slice 3: "Best value" sort (client-side, within each stock section) ----------
  // Key = data-so-value / data-so-unit on the card's price row (so-unit-price 'card-row'): the exact figure the
  // card shows. Every collection fits on one page, so this sorts the whole collection. Rules (PLAN §4):
  // sort inside each stock section (each card <li> carries data-so-sec = i / p / g); units never compared
  // (per ml first, then per pouch, then anything else); products with no value last; ties keep server order.
  // The option only exists while >= 2 cards share a unit, labelled by that unit. The choice lives in our own URL
  // parameter ?so_sort=value (Shopify rejects unknown sort_by values) and is re-applied after every facet
  // re-render (chips, drawer, back/forward). Non-card <li>s (promo blocks) keep their slots.
  var VALUE = 'so-value', UNITS = ['ml', 'pouch'];
  var valueMode = new URL(location.href).searchParams.get('so_sort') === 'value';

  function gridUl() { return document.querySelector('#filter-results ul.grid'); }
  function isCard(li) { return !!li.querySelector('.card--product'); }
  function keyOf(li) {
    if (li._soKey !== undefined) return li._soKey;
    var el = li.querySelector('.card--product [data-so-value]');
    var v = el ? parseInt(el.getAttribute('data-so-value'), 10) : 0;
    return (li._soKey = v > 0 ? { u: el.getAttribute('data-so-unit'), v: v } : null);
  }
  function rankU(u) { var i = UNITS.indexOf(u); return i < 0 ? UNITS.length : i; }
  function rank(k) { return k ? rankU(k.u) : 99; }

  function setMode(on) {
    valueMode = on;
    var u = new URL(location.href);
    if (on) u.searchParams.set('so_sort', 'value'); else u.searchParams.delete('so_sort');
    if (u.href !== location.href) history.replaceState(history.state, '', u.href);
  }

  function reorder(ul) {
    var kids = Array.prototype.slice.call(ul.children), out = kids.slice(), idx = [];
    kids.forEach(function (li, i) { if (!li.hasAttribute('data-so-i')) li.setAttribute('data-so-i', i); });
    function cmp(a, b) {
      if (valueMode) {
        var ka = keyOf(a), kb = keyOf(b), r = rank(ka) - rank(kb);
        if (r) return r;
        if (ka && kb && ka.v !== kb.v) return ka.v - kb.v;
      }
      return a.getAttribute('data-so-i') - b.getAttribute('data-so-i');
    }
    function flush() {
      var cards = idx.map(function (i) { return kids[i]; }).sort(cmp);
      idx.forEach(function (i, j) { out[i] = cards[j]; });
      idx = [];
    }
    var sec = null;
    kids.forEach(function (li, i) {
      // Section boundary = a change of the card <li>'s data-so-sec (i / p / g; the headings were removed 2026-09-29).
      var s = li.getAttribute('data-so-sec');
      if (s && s !== sec) { flush(); sec = s; }
      if (isCard(li)) idx.push(i);
    });
    flush();
    if (out.some(function (li, i) { return li !== kids[i]; })) ul.append.apply(ul, out);
  }

  function applyValue() {
    var sel = document.querySelector('[data-so-cbar-select]'), ul = gridUl();
    if (!sel) return;
    var n = {};
    if (ul) Array.prototype.forEach.call(ul.children, function (li) {
      var k = isCard(li) && keyOf(li);
      if (k) n[k.u] = (n[k.u] || 0) + 1;
    });
    var units = Object.keys(n).filter(function (u) { return n[u] >= 2; }).sort(function (a, b) { return rankU(a) - rankU(b); });
    var opt = sel.querySelector('option[value="' + VALUE + '"]');
    if (!units.length) {
      if (opt) opt.remove();
      if (valueMode) setMode(false);
    } else {
      if (!opt) { opt = document.createElement('option'); opt.value = VALUE; sel.appendChild(opt); }
      opt.textContent = 'Best value · per ' + units.join(' & ');
      if (valueMode) setMode(true);   // a facet re-render pushed a URL without it
    }
    if (ul) reorder(ul);
    var label = document.querySelector('[data-so-cbar-sort]');
    if (valueMode) {
      sel.value = VALUE;
      if (label) label.textContent = 'Best value';
    } else if (sel.value === VALUE || !opt) {
      var checked = document.querySelector('#facets .js-drawer-sort-by:checked');
      if (checked) sel.value = checked.value;
      if (label && sel.selectedIndex > -1) label.textContent = sel.options[sel.selectedIndex].text;
    }
  }

  function applySort(value) {
    var radio = null;
    sortRadios().forEach(function (r) { if (r.value === value) radio = r; });
    var facets = document.querySelector('facet-filters');
    if (radio && facets) {
      radio.checked = true;
      radio.dispatchEvent(new Event('input', { bubbles: true }));
      return;
    }
    // No facet drawer on this page (filtering off): plain navigation keeps sorting working.
    var u = new URL(location.href);
    u.searchParams.set('sort_by', value);
    u.searchParams.delete('page');
    location.href = u.toString();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var about = t.closest('[data-so-about-open]');
    if (about) { e.preventDefault(); open(about); return; }
    if (sheet && !sheet.hidden && t.closest('[data-so-about-close]') && sheet.contains(t)) { e.preventDefault(); close(); return; }
    var filter = t.closest('[data-so-cbar-filter]');
    if (filter) {
      var facets = document.querySelector('facet-filters');
      if (facets && typeof facets.open === 'function') { e.preventDefault(); facets.open(filter); }
    }
  });

  document.addEventListener('change', function (e) {
    var sel = e.target;
    if (!sel || !sel.matches || !sel.matches('[data-so-cbar-select]')) return;
    var label = document.querySelector('[data-so-cbar-sort]');
    if (label && sel.selectedIndex > -1) label.textContent = sel.options[sel.selectedIndex].text;
    if (sel.value === VALUE) { setMode(true); applyValue(); return; }
    if (valueMode) {
      setMode(false);
      var checked = document.querySelector('#facets .js-drawer-sort-by:checked');
      // Back to the sort the page was already rendered with: just restore the server order, no fetch.
      if (checked && checked.value === sel.value) { applyValue(); return; }
    }
    applySort(sel.value);
  });

  // A sort picked in the filter drawer (a server sort) ends Best value. Clicking the already-checked radio fires
  // no 'input', so restore the server order here too.
  document.addEventListener('click', function (e) {
    if (!valueMode || !e.target || !e.target.matches || !e.target.matches('#facets .js-drawer-sort-by')) return;
    setMode(false);
    applyValue();
  });

  // ---------- quick-filter chips (slice 1b, snippets/so-coll-chips.liquid) ----------
  // Chips live inside #filter-results, which facet-filters.js re-renders after every change (chip, drawer,
  // back/forward): their selected state always comes from the server. Here: send a chip through the theme's
  // AJAX filter, keep the row's sideways scroll position across re-renders, and set the edge fade.
  var chipsLeft = 0;
  function scroller() { return document.querySelector('[data-so-chips-scroller]'); }
  function fade() {
    var s = scroller();
    if (!s) return;
    var max = s.scrollWidth - s.clientWidth;
    var f = [];
    if (max > 3 && s.scrollLeft > 3) f.push('l');
    if (max > 3 && s.scrollLeft < max - 3) f.push('r');
    if (f.length) s.setAttribute('data-fade', f.join(' ')); else s.removeAttribute('data-fade');
  }
  function afterRender() {
    var s = scroller();
    if (!s) return;
    if (chipsLeft) s.scrollLeft = chipsLeft;
    // The tapped chip changes width (count <-> ✕); keep it wholly in view, sideways only (never scrolls the page).
    var c = document.activeElement;
    if (c && s.contains(c)) {
      var pad = parseFloat(getComputedStyle(s).paddingLeft) || 0;
      var l = c.offsetLeft - s.offsetLeft, r = l + c.offsetWidth;
      if (r > s.scrollLeft + s.clientWidth - pad) s.scrollLeft = r - s.clientWidth + pad;
      else if (l < s.scrollLeft + pad) s.scrollLeft = l - pad;
    }
    chipsLeft = s.scrollLeft;
    fade();
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-so-chips-scroller]')) { chipsLeft = t.scrollLeft; fade(); }
  }, { capture: true, passive: true });

  function applyChip(chip, evt) {
    var facets = document.querySelector('facet-filters');
    if (!facets || typeof facets.applyFilters !== 'function') return false;
    var u = new URL(chip.getAttribute('href'), location.href);
    u.searchParams.delete('page');
    u.searchParams.delete('section_id');
    var s = scroller();
    if (s) chipsLeft = s.scrollLeft;
    // Instant feedback; the re-render that follows replaces the row with the server's state.
    var on = chip.getAttribute('aria-pressed') !== 'true';
    chip.setAttribute('aria-pressed', String(on));
    chip.classList.toggle('is-on', on);
    facets.applyFilters(u.searchParams.toString(), evt);
    return true;
  }

  document.addEventListener('click', function (e) {
    var chip = e.target && e.target.closest && e.target.closest('[data-so-chip]');
    if (!chip || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    if (applyChip(chip, e)) e.preventDefault();
  });
  // role="button" on a link: Space activates it too.
  document.addEventListener('keydown', function (e) {
    if (e.key !== ' ' || !e.target || !e.target.matches || !e.target.matches('[data-so-chip]')) return;
    e.preventDefault();
    e.target.click();
  });

  // Header fact line follows the filters: "N of T products" while narrowed, the unfiltered line otherwise.
  function syncFact() {
    var f = document.querySelector('[data-so-coll-fact]');
    var c = document.querySelector('#filter-results [data-so-coll-count]');
    if (!f || !c) return;
    var n = parseInt(c.getAttribute('data-so-coll-count'), 10);
    var t = parseInt(f.getAttribute('data-so-coll-total'), 10);
    if (isNaN(n) || isNaN(t)) return;
    f.textContent = n < t ? n + ' of ' + t + ' products' : f.getAttribute('data-so-coll-fact-base');
  }

  document.addEventListener('on:facet-filters:updated', function () { syncBar(); afterRender(); syncFact(); });
  window.addEventListener('popstate', function () {
    valueMode = new URL(location.href).searchParams.get('so_sort') === 'value';
    setTimeout(syncBar, 600);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', applyValue); else applyValue();
  window.addEventListener('resize', fade, { passive: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fade); else fade();

  // ---------- A2: soft shadow on the bar once it is actually stuck under the header ----------
  // position:sticky's computed "top" is the same px value collection-banner.css puts on .so-cbar
  // (var(--header-height)), so comparing it to the bar's own bounding rect needs no separate sentinel
  // and stays correct if main.js updates --header-height later (e.g. announcement bar collapsing).
  var stuckTicking = false;
  function checkStuck() {
    var bar = document.querySelector('[data-so-cbar]');
    if (!bar) return;
    // Stick directly under the header as it is NOW: the desktop header shrinks on scroll (122 → ~81px) but
    // --header-height keeps the full height, which left a gap with products showing through above the bar.
    var hdr = document.querySelector('store-header');
    if (hdr) bar.style.top = Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) + 'px';
    var top = parseFloat(getComputedStyle(bar).top) || 0;
    bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= top + 0.5);
  }
  function onScroll() {
    if (stuckTicking) return;
    stuckTicking = true;
    requestAnimationFrame(function () { checkStuck(); stuckTicking = false; });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  // The header shrinks with a transition after the scroll event: follow its size as it animates.
  var hdrEl = document.querySelector('store-header');
  if (hdrEl && window.ResizeObserver) new ResizeObserver(onScroll).observe(hdrEl);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', checkStuck); else checkStuck();
})();
